import {BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, Groups} from "@leap4/frontend";
import type {GridColDef, GridRenderCellParams} from "@leap4/frontend";
import {AdvertiserLoginsBaseUrl} from "../../../config/generals";
import {urlService} from "../../routing/urlsService";
import {Link} from "react-router-dom";
import {RootState} from "../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";

const fields = {
    publisherName: 1,
    advertiserName: 1,
}

const getParams: IGetAllParams = {
    fields
}
let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${AdvertiserLoginsBaseUrl}`
    }, fields, {
        created: {},
        isActive: {},
        updated: {},
        name: {editLinkFunc: (id: string) => urlService.editAdvertiserLogins(id)}
    })
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;
    const publisherCol = columns.find(x => (x.field === "publisherName"));
    const advertiserCol = columns.find(x => (x.field === "advertiserName"));
    publisherCol.headerName = "Publisher"
    advertiserCol.headerName = "Advertiser"
    publisherCol.renderCell = (params: GridRenderCellParams) => {
        const publisherOrgId = params.id.toString().split("_")[0];
        return <Link to={urlService.editOrganization(publisherOrgId)}><strong>{params.value}</strong></Link>
    };
    advertiserCol.renderCell = (params: GridRenderCellParams) => {
        const advertiserOrgId = params.id.toString().split("_")[1];
        return <Link to={urlService.editOrganization(advertiserOrgId)}><strong>{params.value}</strong></Link>
    };
}

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const AdvertiserLoginsDashboardModule = (props: PropsFromRedux) => {
    setStoreAndColumns();

    return (
        <GenericItemsForm
            organization={props.selectedOrganization}
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.advertiserLogins(),
                text: "Advertiser logins Dashboard",
                icon: <Groups/>
            }}
            tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
            getAllParams={getParams}

        />
    );
};

export default connector(AdvertiserLoginsDashboardModule)
